import {useState} from 'react';
import s from './ReviewCard.module.scss';
import StarRating from '../../components/StarRating/StarRating';

const ReviewCard = ({
  title,
  rezdyId,
  tourId,
  stars,
  date,
  userType,
  userName,
  reviewTitle,
  review,
  thumb = null,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const formatReviewDate = (value) => {
    if (!value) return '';

    const normalized = typeof value === 'string' ? value.replace(' ', 'T') : value;
    const parsed = new Date(normalized);

    if (Number.isNaN(parsed.getTime())) {
      return String(value).replace(/:\d{2}$/, '');
    }

    return new Intl.DateTimeFormat('ja-JP', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(parsed);
  };

  const toggleReview = () => {
    setIsExpanded(current => !current);
  };

  const tourUrl = `/tours/${tourId || rezdyId}`;
  const shouldShowMore = review?.length > 100;

  return (
    <div className={s.root}>
      {thumb && (
        <div className={s.thumbnailWrapper}>
          <a href={`/tours/${rezdyId}`}>
            <img src={thumb} alt={`${userName}のレビューサムネイル`} className={s.thumbnail} />
          </a>
        </div>
      )}

      <div className={s.textWrapper}>
        <a className={s.title} href={tourUrl}>
          {title ?? ''}
        </a>

        <div className={s.rating}>
          <StarRating score={stars} />
        </div>

        {reviewTitle && (
          <h4 className={s.reviewTitle}>{reviewTitle}</h4>
        )}

        <p className={s.reviewText}>{review}</p>

        {shouldShowMore && (
          <button className={s.toggleReviewButton} type="button" onClick={toggleReview}>
            続きを読む
          </button>
        )}

        <div className={s.details}>
          <span>{userName ? `投稿者：${userName}` : 'レビュー'}</span>
          {userType && <span>{userType}</span>}
          <span>{formatReviewDate(date)}</span>
        </div>
      </div>

      {isExpanded && (
        <div className={s.modalOverlay} role="dialog" aria-modal="true" onClick={toggleReview}>
          <div className={s.modalContent} onClick={(event) => event.stopPropagation()}>
            <div className={s.modalHeader}>
              <div>
                {reviewTitle && <h4>{reviewTitle}</h4>}
                <p>{title}</p>
              </div>
              <button type="button" onClick={toggleReview} aria-label="閉じる">×</button>
            </div>

            <div className={s.modalRating}>
              <StarRating score={stars} />
            </div>

            <p className={s.modalReviewText}>{review}</p>

            <div className={s.modalDetails}>
              <span>{userName ? `投稿者：${userName}` : 'レビュー'}</span>
              {userType && <span>{userType}</span>}
              <span>{formatReviewDate(date)}</span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReviewCard;
